import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './i18n'
import './lib/utils/strMethods'
import App from './App'
import ruLocale from 'date-fns/locale/ru'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { SnackbarProvider } from 'notistack'
import { StylesProvider } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/core'
import { AuthStoreProvider } from 'context/AuthStore'
import { asterTheme } from 'asterX-UI'
import { ModalbarProvider } from 'modules/Modalbar'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import 'react-18-image-lightbox/style.css'
import { register } from 'swiper/element/bundle'
import CarContextProvider from 'context/carStore'

register()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <ThemeProvider theme={asterTheme}>
    <StylesProvider>
      <BrowserRouter>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ruLocale}>
          <SnackbarProvider
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
            autoHideDuration={3000}
          >
            <ModalbarProvider>
              <CarContextProvider>
                <Switch>
                  <Route
                    path="/"
                    render={props => (
                      <AuthStoreProvider {...props}>
                        <App {...props} />
                      </AuthStoreProvider>
                    )}
                  />
                </Switch>
              </CarContextProvider>
            </ModalbarProvider>
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </BrowserRouter>
    </StylesProvider>
  </ThemeProvider>
)
